import React, { Dispatch, SetStateAction } from "react";
import { Link, useNavigate } from "react-router-dom";
// import BarChart from "./BarChart";
// import ComplaintsPieChart from "./ComplaintsPieChart";
import ComplaintsTable from "./ComplaintsTable";
// import { useMedium } from "../../hooks/useMedium";
import { IComplaint } from "../../exports/interfaces";
import { formatDate } from "../../exports/functions";
import useMobile from "../../hooks/useMobile";
import { FilePlus2 } from "lucide-react";
import { usePermission } from "../../hooks/usePermission";
import { useOption } from "../../context/OptionContext";

const Complaints = ({
  complaint,
  setComplaint,
}: {
  complaint: IComplaint[];
  setComplaint: Dispatch<SetStateAction<IComplaint[]>>;
}) => {
  const isMobile = useMobile();
  const navigate = useNavigate();
  const { canCreate } = usePermission();
  const { categories } = useOption();
  // const isMedium = useMedium();
  // const now = new Date();
  // const complaintThisMonth = complaint.filter((n) => {
  //   const date = new Date(n.createdAt);

  //   return (
  //     date.getMonth() === now.getMonth() &&
  //     date.getFullYear() === now.getFullYear()
  //   );
  // }).length;
  const complaintCount = complaint.length;
  const lastUpdated = complaint.length
    ? new Date(
        Math.max(...complaint.map((n) => new Date(n.createdAt).getTime())),
      )
    : null;
  const complaintStatuses = categories.find(
    (item) => item.name === "Complaint Priority",
  );

  const complaintStatusCounts =
    complaintStatuses?.dropdowns.map((status) => ({
      label: status.label,
      count: complaint.filter((item) => item.status === status.label).length,
    })) ?? [];

  // const chartData = [
  //   { label: "Urgent", value: urgentCount },
  //   { label: "Not Urgent", value: notUrgentCount },
  //   { label: "Regular", value: regularCount },
  //   { label: "Solved", value: solvedCount },
  // ];

  const complaintsProcessingCount = complaint.filter((x) =>
    ["Received", "Under Review", "Investigating"].includes(x?.status ?? ""),
  ).length;

  return (
    <>
      <div
        id="complaints-header"
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <div>
          <h3>Complaints</h3>
          <small>
            {complaintStatusCounts
              .slice(0, 3)
              .map(
                (item) =>
                  `${item.count.toString().padStart(2, "0")} ${item.label.toUpperCase()}`,
              )
              .join(", ")}
          </small>
        </div>
        {canCreate("complaints") && (
          <button
            className="btn px-3 btn-badge"
            onClick={() => navigate("/complaints/create")}
          >
            <i className={`${!isMobile ? "me-2" : ""}`}>
              <FilePlus2 size={20} />
            </i>
            {!isMobile && "Create Complaint"}
          </button>
        )}
      </div>

      <div className="row g-2">
        <div className="col-md-3">
          <div
            id="total-complaints"
            className="dashboard-card h-100 d-flex flex-column"
          >
            <div className="card-body">
              <p className="count-card-heading">Total Complaints Registered</p>
              <h2>{complaintCount.toString().padStart(2, "0")}</h2>
            </div>
            <div className="d-flex align-items-center justify-content-between flex-wrap mt-3">
              <small>
                <span>Last Updated:</span> {formatDate(lastUpdated)}
              </small>
              <Link to="/complaints-list">
                <small>View all</small>
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div
            id="complaint-types"
            className="dashboard-card h-100 d-flex flex-column"
          >
            <div className="card-body">
              <p className="mb-1 count-card-heading">Types of Complaints</p>
              <div className="row g-3 mb-2">
                {complaintStatusCounts.slice(0, 4).map((item) => (
                  <div key={item.label} className="col-md-3 col-6">
                    <p>{item.label}</p>
                    <h2 className="my-0">
                      {item.count.toString().padStart(2, "0")}
                    </h2>
                  </div>
                ))}
              </div>
            </div>
            <div className="text-start">
              <small>
                <span>Last Updated:</span> {formatDate(lastUpdated)}
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div
            id="complaints-processing"
            className="dashboard-card h-100 d-flex flex-column"
          >
            <div className="card-body">
              <p className="count-card-heading">Complaints Processing</p>
              <h2>{complaintsProcessingCount.toString().padStart(2, "0")}</h2>
            </div>
            <div className="d-flex align-items-center justify-content-between flex-wrap mt-3">
              <small>Last Updated: {formatDate(lastUpdated)}</small>
              <Link to="/">
                <small>View all</small>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row g-2 dashboard-section">
        {/* <div className="col-lg-9">
          <div className="dashboard-card h-100">
            <div className="card-body">
              <h6>MONTHY COMPLAIN STATISTICS</h6>
              <div className="row">
                <div className="col-md-9">
                  <BarChart />
                </div>
                <div className="col-md-3 d-flex align-items-center justify-content-center">
                  <div className="dashboard-card inner-dashboard-card">
                    <div className="card-body text-center">
                      <p>Complains this month</p>
                      <h2>{complaintThisMonth}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="dashboard-card h-100">
            <div className="card-body">
              <h6>COMPLAIN STATISTICS</h6>
              <div className="text-center">
                <ComplaintsPieChart data={chartData} width={180} height={180} />
              </div>
              <div className="mt-3 d-flex flex-wrap justify-content-center">
                {chartData.map((item, i) => {
                  const colors = ["#8B0000", "#ff6b6b", "#f06292", "#f8b4b4"];
                  return (
                    <div
                      key={i}
                      className="d-flex justify-content-center align-items-center mb-2"
                      style={{ width: `${isMedium ? "100%" : "50%"}` }}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <span
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: colors[i % colors.length],
                            display: "inline-block",
                          }}
                        ></span>
                        <small>{item.label}</small>
                        <small>{item.value.toString().padStart(2, "0")}</small>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div> */}
        <div id="complaints-table" className="row g-2 dashboard-section">
          <div className="col-md-12">
            <ComplaintsTable
              complaint={complaint}
              setComplaint={setComplaint}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Complaints;
